
import { i18nText } from '@/locales';

import {Component} from 'vue-property-decorator';
import BaseDataForm from '@/UI/components/Helpers/BaseForm/BaseDataForm.vue';
import PageTitle from '@/UI/components/common/PageTitle.vue';
import { mixins } from "vue-class-component";
import { ProxyTableData } from '@/UI/components/Helpers/ProxyTableData';
import { RouterNameEnum } from '@/router/router.types';
import AppFilterTable from "@/UI/components/extFilter/AppFilterTable.vue";
import { FiltersData, getRouteFilter } from '@/entity/filters/extFilter';
import {SaleTargetsColumns} from '@/UI/pages/reports/lib/columns'
import { SalonsStore } from '@/store/modules/Salons';
import { AppFilters } from '@/UI/components/extFilter/AppFilters';
import { SalonsMix } from '@/UI/mixins/SalonsMix';
import { RouterProperties } from '@/router/routerProperties';

@Component({
    components: {
        BaseDataForm,
        PageTitle,
        AppFilterTable
    }
})

export default class SalesTarget extends mixins (
    ProxyTableData,
    SaleTargetsColumns,
    SalonsMix,
) {
    RouterNames = RouterNameEnum;
    filtersData = new FiltersData();

    async created(): Promise<void> {
        this.formReady = false
        try {
            await SalonsStore.fetchAll({limit: this.AppPageParams.pageSize})
            this.setFilters(this);
        } catch (e) {
            console.error(e)
        } finally {
            this.formReady = true
        }
    }

    setFilters(that: any): void {
        this.filtersData.filters.push(
            {
                key: 0,
                type: 'datetimerange',
                label: i18nText("Период "),
                defaultValue: 0,
                placeholder: i18nText("Не указано"),
                value: [],
                source: this.salons?.data,
                fieldNames: ['salon_id'],
                storeSource: AppFilters.loyaltySubscription,
                filtered: false,
                async onChange(value: any) {
                    // await that.setRouteFilterTable(RouterProperties.salons, { partner_id: value }, false);
                },
            },
            {
                key: 1,
                type: "source",
                label: i18nText("Категории улсуг"),
                defaultValue: 0,
                value: Number(getRouteFilter("partner_id")),
                // source: this.partners,
                placeholder: i18nText("Не указано"),
                filtered: false,
                async onChange(value: any) {
                    // await that.setRouteFilterTable(RouterProperties.salons, { partner_id: value }, false);
                },
            },
            {
                key: 2,
                type: "source",
                label: i18nText("Услуги"),
                defaultValue: 0,
                value: Number(getRouteFilter("partner_id")),
                // source: this.partners,
                placeholder: i18nText("Не указано"),
                filtered: false,
                async onChange(value: any) {
                    // await that.setRouteFilterTable(RouterProperties.salons, { partner_id: value }, false);
                },
            },
            {
                key: 3,
                type: "source",
                label: i18nText("Категории товаров"),
                defaultValue: 0,
                value: Number(getRouteFilter("partner_id")),
                // source: this.partners,
                placeholder: i18nText("Не указано"),
                filtered: false,
                async onChange(value: any) {
                    // await that.setRouteFilterTable(RouterProperties.salons, { partner_id: value }, false);
                },
            },
            {
                key: 4,
                type: "source",
                label: i18nText("Товары"),
                defaultValue: 0,
                value: Number(getRouteFilter("partner_id")),
                // source: this.partners,
                placeholder: i18nText("Не указано"),
                filtered: false,
                async onChange(value: any) {
                    // await that.setRouteFilterTable(RouterProperties.salons, { partner_id: value }, false);
                },
            },
            {
                key: 5,
                type: "source",
                label: i18nText("Должности"),
                defaultValue: 0,
                value: Number(getRouteFilter("partner_id")),
                // source: this.partners,
                placeholder: i18nText("Не указано"),
                filtered: false,
                async onChange(value: any) {
                    // await that.setRouteFilterTable(RouterProperties.salons, { partner_id: value }, false);
                },
            },
        )
    }
}
